import { getBrandingInfo } from "./services/branding.service";

export const CANONICAL_ORIGIN = "https://motoscheduler.com";

export const isDevHostname = (hostname: string): boolean => {
  const normalized = hostname.toLowerCase();
  return (
    normalized === "localhost" ||
    normalized === "127.0.0.1" ||
    normalized.endsWith(".local")
  );
};

export const isPlatformHostname = (hostname: string): boolean => {
  const normalized = hostname.toLowerCase();
  return (
    isDevHostname(normalized) ||
    normalized === "motoscheduler.com" ||
    normalized === "www.motoscheduler.com"
  );
};

export const checkHostRedirect = async (
  hostname: string = typeof window !== "undefined"
    ? window.location.hostname
    : ""
): Promise<string | null> => {
  const normalized = hostname.toLowerCase();

  if (isPlatformHostname(normalized)) {
    return null;
  }

  const info = await getBrandingInfo(normalized);
  if (!info.exists) {
    return CANONICAL_ORIGIN;
  }

  return null;
};

export const getHostRedirectUrl = (
  hostname: string,
  domainExists = true
): string | null => {
  const normalized = hostname.toLowerCase();

  if (isPlatformHostname(normalized)) {
    return null;
  }

  if (!domainExists) {
    return CANONICAL_ORIGIN;
  }

  return null;
};
